import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import clsx from 'clsx'
import CommonLayout from 'components/layout/common/index'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import ResponsiveImage from 'components/images/responsive-image'
import Typo from 'constants/typography'
import { PAGE_NAME } from 'pages/const'
import { BANNER_SRC, BANNER_TEXT } from './const'
import styles from './style.scss'
import BasePage from '../base'

class Press extends BasePage {
  static getInitialProps({ store, res, req, isServer }) {
    if (isServer) {
      BasePage.loadInitialContentFromServer({ req, res, store })
    } else {
      BasePage.loadInitialContentFromClient(req, res, store)
    }

    return {}
  }

  render() {
    const { isPhone, t } = this.props
    const subtitle = hasLocizeTranslation(
      t,
      BANNER_TEXT.subtitleKey,
      BANNER_TEXT.subtitle,
    )
    const image = BANNER_SRC.en[isPhone ? 'mobile' : 'desktop']

    return (
      <CommonLayout
        noSidePadding
        pageName={PAGE_NAME.press}
        style={{ marginBottom: '-50px', minHeight: '0' }}
      >
        <style jsx>{styles}</style>
        <div className="press__wrapper">
          <ResponsiveImage
            alt="Press Page"
            imgRatio={image.ratio}
            src={image.src}
          />
          <div className="press__text">
            <span className={clsx('press__title', Typo.h3)}>
              {hasLocizeTranslation(t, BANNER_TEXT.titleKey, BANNER_TEXT.title)}
            </span>
            <span className={clsx('press__subtitle', Typo.subtitle1)}>
              {subtitle}
            </span>
          </div>
        </div>
      </CommonLayout>
    )
  }
}

Press.propTypes = {
  internationalization: PropTypes.shape({}).isRequired,
  isPhone: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
}

export { Press }

const Extended = withI18next(['global'])(Press)

export default connect(
  /* istanbul ignore next */
  (state) => ({
    internationalization: state.internationalization,
    isPhone: state.device.isPhone,
  }),
)(Extended)
